import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import * as FIELDS from '../../fields';
import { CREATIVE_VIDEO_REPORT_ID } from './creativeVideoReportId';

const emptyColumns = [
    FIELDS.IS_ACTIVE,
    FIELDS.CREATIVE_NAME,
    FIELDS.CAMPAIGN_NAME,
    FIELDS.ID,
    FIELDS.ACTIONS_COLUMN,
].map(createFooterMapper(CREATIVE_VIDEO_REPORT_ID));

const creativeReportFooterColumnDefinition = [...emptyColumns];

export default creativeReportFooterColumnDefinition;
